// Module
var code = `<div class="quickTreeOuter" style="{{>visibility}}" >
    <canvas id="tree_{{.myId}}" 
        on-mousedown="@this.onMouseDown(event)" 
        on-mousemove="@this.onMouseMove(event)" 
        on-mouseup="@this.onMouseUp(event)" 
        on-wheel="@this.onMouseWheel(event)" 
        on-mousewheel="@this.onMouseWheel(event)" 
        on-dblclick="@this.onDoubleClick(event)"
        on-mouseleave="@this.onMouseLeave(event)" 
        style="cursor:{{currentCursor}};">
    </canvas>
</div>`;
// Exports
export default code;